// extracted by css-extract-rspack-plugin
export default {"pagination":"lxBP0"};